import logo from "../../../assets/logo-mark.png";
import s from "./preloader.module.css";

/**
 * Брендированный прелоадер Бай.Спорт.
 * @param {"page"|"inline"} [variant="page"] — на весь экран или компактный
 * @param {string} [label] — подпись под анимацией
 */
export default function Preloader({ variant = "page", label } = {}) {
  return (
    <div
      className={`${s.root} ${variant === "inline" ? s.inline : s.page}`}
      role="status"
      aria-live="polite"
      aria-label={label || "Загрузка"}
    >
      <div className={s.stage} aria-hidden>
        <span className={s.ring} />
        <span className={s.ringSoft} />
        <img src={logo} alt="" className={s.logo} />
      </div>
      {label ? <p className={s.label}>{label}</p> : null}
    </div>
  );
}
